// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QlhZ","input":"styles_input__16PwF"};